export default __webpack_public_path__ + "static/media/googlePlay_download_hover.164f4e70.svg";